export default "__VITE_ASSET__DAjiOLTO__"